import { useNavigate } from 'react-router';
import { useAppSelector } from '../../Hooks/Hooks';
import { RootState } from '../../Redux/Store';
import { EVENT, LEAD, SCREEN } from '../../Constants/AnalyticsConstants';
import { fbLogEvent } from '../../Helpers/FirebaseHelper';
import { isEntitled } from '../../Utils/ContentOrConfigUtil';
import './ManageMenu.scss';

const manageMenu = [
  {
    label: 'My Profile',
    slug: 'myProfile',
    redirectUrl: '/profile',
  },
  {
    label: 'Preferences',
    slug: 'preferences',
    redirectUrl: '/preferences',
  },
];

const ManageMenu = () => {
  const navigate = useNavigate();
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { configTableData } = useAppSelector((state: RootState) => state.ContentOrConfig);
  const handleClick = (item: any) => {
    if (item?.slug === 'myProfile') {
      fbLogEvent(EVENT.UE_MY_PROFILE, {
        screen: SCREEN.MANAGE_MENU,
        lead: LEAD.MANAGE_MENU,
      });
    }
    if (item?.slug === 'preferences') {
      fbLogEvent(EVENT.UE_PREFERENCES, {
        screen: SCREEN.TAB_BAR,
        lead: SCREEN.MANAGE_MENU,
      });
    }
    return item?.redirectUrl && navigate(item?.redirectUrl);
  };

  return (
    <div className="ManageMenu_Container">
      <div className="Cards_Container">
        {manageMenu?.map((menu: any) => {
          const isPreferences = menu?.slug === 'preferences';
          const isNotEntitled = !isEntitled(
            memberData?.member,
            configTableData?.FPO_APP_CONFIG?.APP_INIT,
            'tab',
            menu?.slug,
          );

          if (!(isPreferences && isNotEntitled)) {
            return (
              <div
                className={`Card ${menu?.slug}`}
                onClick={() => handleClick(menu)}
                key={menu?.slug}
              >
                <p>{menu?.label}</p>
                <img src="/oo/assets/icon/more-arrow.svg" alt="Arrow" />
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default ManageMenu;
